export default __webpack_public_path__ + "bfef2f3d0328519a84ae368d626c07a3.svg";